var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"value":_vm.value,"color":_vm.color,"icon":!_vm.content ? _vm.iconInContentBadge : undefined,"content":_vm.content,"offset-x":_vm.offsetX,"offset-y":_vm.offsetY,"bordered":_vm.bordered}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }